module.exports = __webpack_public_path__ + "static/media/CallToAction_elImage_340996.691fd0fd.jpg";